import SettingFrame from "../../../../../components/@settings/SettingFrame";
import UpdateCountry from "../../../../../components/@region/countries/UpdateCountry";

import { routeTypes } from "../../../../../hooks/useSystemRoutes";

export default function CountryUpdatePage() {

    let routeType = routeTypes.admin

    return (
        <SettingFrame
            routeType={routeType}
        >
            <UpdateCountry
                routeType={routeType}
            />
        </SettingFrame>
    )
}